export default __webpack_public_path__ + "static/media/logo-webcol-preta.9473fe63.png";